import type { FC, Ref } from "react";
import { Paper, Stack, Text } from "@mantine/core";

const QR_CODE_MAX_SIZE = 200;
const DESCRIPTION_MAX_WIDTH = 220;

type PhoneUploadQrCardProps = {
  canvasRef: Ref<HTMLCanvasElement>;
  title?: string;
  description?: string;
};

// QR code opening an upload page on the user's phone (order detail, help request and review pages)
export const PhoneUploadQrCard: FC<PhoneUploadQrCardProps> = ({
  canvasRef,
  title = "Depuis votre téléphone",
  description = "Scannez le code : les photos arrivent ici.",
}) => (
  <Paper withBorder radius="lg" bg="appBackground" px="s4" py="s5">
    <Stack align="center" justify="center" gap="s3" ta="center" h="100%">
      <Paper withBorder radius="md" shadow="xs" p="s3">
        <canvas
          ref={canvasRef}
          aria-label="QR code de téléversement"
          style={{
            display: "block",
            maxWidth: QR_CODE_MAX_SIZE,
            maxHeight: QR_CODE_MAX_SIZE,
          }}
        />
      </Paper>
      <Stack gap="s1" align="center">
        <Text variant="strong">{title}</Text>
        <Text variant="caption" maw={DESCRIPTION_MAX_WIDTH}>
          {description}
        </Text>
      </Stack>
    </Stack>
  </Paper>
);
